import { IValidateResult } from '@formily/validator'

/**
 *  密码长度为 6~20 位，必须包含数字、字母、特殊符号
 */
export const passwordStrengthValidator = (
  value: string
): IValidateResult | null => {
  if (!(value.length >= 6 && value.length <= 20)) {
    return {
      type: 'error',
      message: '密码长度有效范围为 6~20 位'
    }
  }
  if (
    !(
      /\d/.test(value) &&
      /[a-z]/.test(value) &&
      /[A-Z]/.test(value) &&
      /[^A-Za-z0-9]/.test(value)
    )
  ) {
    return {
      type: 'error',
      message: '密码必须同时包含数字、小写字母、大写字母、特殊符号'
    }
  }
  return null
}
